export enum FileTypeEnum {
  IMAGE = 'image',
  PDF = 'pdf',
  KFPX = 'kfpx',
}
